/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { SpeechRecognitionService } from "./types";

const speechRecognition = CustomPlatform.select<() => SpeechRecognitionService>(
  {
    web: () => require("./speech-recognition.web").default,
    tvOS: () => require("./speech-recognition.tvos").default,
    androidTV: () => require("./speech-recognition").default,
    native: () => require("./speech-recognition").default,
    default: () => require("./speech-recognition.web").default,
  },
)();

export default speechRecognition;
